import {t} from 'i18next';
import {z} from 'zod';

export const keywordHighlightSchema = () =>
  z.object({
    keywordGrpName: z
      .string()
      .trim()
      .min(1, {
        message: t('keywordHighlighting.addEditKeyword.keywordGrpRequired'),
      })
      .max(255, {
        message: t('keywordHighlighting.addEditKeyword.keywordGrpMaxChar'),
      })
      .regex(/^[^~`!$%^()+{}|\\"',<>]+$/, {
        message: t('keywordHighlighting.addEditKeyword.keywordInvalidChar'),
      }),
    description: z
      .string()
      .trim()
      .min(1, {
        message: t('keywordHighlighting.addEditKeyword.descRequired'),
      })
      .max(256, {
        message: t('keywordHighlighting.addEditKeyword.desciptionMaxChar'),
      })
      .regex(/^[^*;\\'\\]*$/, {
        message: t('keywordHighlighting.addEditKeyword.descInvalidChar'),
      }),
    keywords: z
      .string()
      .trim()
      .min(1, {
        message: t('keywordHighlighting.addEditKeyword.emptyKeyword'),
      })
      .max(4000, {
        message: t('keywordHighlighting.addEditKeyword.keywordMaxChar'),
      }),
    color: z.string(),
  });
export type keywordHighlightForm = z.infer<
  ReturnType<typeof keywordHighlightSchema>
>;
